import React from "react";

import { useDrop } from "react-dnd";

export const InputDropZone = ({ data, handleDrop }) => {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: "input",
    drop: (item, monitor) => {
      console.log(item,"monitorgg")
      // if(data.sectionPath !==0){
         handleDrop(item, data.columnPath, data.sectionPath , data.columnKey);
      // }
      // else{
      //   alert("You can not Drop new fields section one")
      // }
     
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });
  const isActive = isOver;
  return (
    <div
      className="dropZone"
      style={{
        height: "40px",
        backgroundColor: isActive ? "green" : "",
      }}
      ref={drop}
    />
  );
};

export const SectionDropZone = ({ sectionPath, handleDropSection }) => {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: "section",
    drop: (item, monitor) => {
      handleDropSection(item, sectionPath);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });
  const isActive = isOver;
  return (
    <div
      className="dropZone"
      style={{
        height: "40px",
        backgroundColor: isActive ? "green" : "",
      }}
      ref={drop}
    />
  );
};
